import Collection from 'lib/Collection';
import GroupMembership from 'entities/GroupMembership';
import GroupMemberships from 'collections/GroupMemberships';
import Subscriber from 'entities/Subscriber';
import PotentialChatMember from 'entities/PotentialChatMember';

class RootGroupMemberships extends Collection<PotentialChatMember> {
  constructor(models: Array<PotentialChatMember>, options: any) {
    super(models, options);
    this.comparator = (a, b) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      return a.getSortKey().localeCompare(b.getSortKey());
    };
    this.sort();
  }

  initialize() {
    // FIXME: Replace PCM with GCQ before release
    this.url = '/chats/members/potential/';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof PotentialChatMember' is missing the f... Remove this comment to see the full error message
    this.model = PotentialChatMember;
  }

  // Convert from PotentialChatMember objects to GroupMembership objects
  getGroupMemberships() {
    // FIXME: There is no created_at date being returned
    // by the backend from /chats/members/(search/eligible/potential) query,
    // so we have no date to put for each user's subscribed_at or created_at
    // dates. Right now we are just using a placeholder value.
    return new GroupMemberships(
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      this.models.map((member) => {
        return new GroupMembership({
          id: member.getUser().id,
          user: new Subscriber({
            id: member.getUser().id,
            name: member.getName(),
            note: member.getNote(),
            role: member.getRole(),
            first_name: member.getFirstName(),
            last_name: member.getLastName(),
            contactability_status: member.getUser().getContactabilityStatus(),
            signature: member.getUser().getSignature(),
            office_hours: member.getUser().getOfficeHours(),
            color: member.getUser().getColor(),
            initials: member.getUser().getInitials(),
            blocked: member.getUser().isBlocked(),
          }),
          created_at: new Date(0), // Use UNIX Epoch as placeholder
          group_id: null,
          can_become_owner: false,
          role: member.getRole(),
          can_unsubscribe: false,
          can_chat: member.isEligible(),
        });
      })
    );
  }
}

export default RootGroupMemberships;
